import { render, staticRenderFns } from "./SettingsDesktop.vue?vue&type=template&id=f4ed053c"
import script from "./SettingsDesktop.vue?vue&type=script&lang=js"
export * from "./SettingsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports